import { Grid } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from 'components/forms/Checkbox'

const A3PCheckbox = ({ label, onChange, checked, sx }) => (
    <Grid bgcolor={'primary.veryLight'} color={'third'} sx={{ borderRadius: 2, padding: 1.5, ...sx }} >
        <Checkbox label={label} sx={{ padding: 0 }} onChange={onChange} checked={checked} />
    </Grid>
)

A3PCheckbox.propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    sx: PropTypes.shape({}),
}

export default A3PCheckbox